import loopCreate from './loopCreate';
import loopFix from './loopFix';
import loopDestroy from './loopDestroy';
export default {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};


//////////////////
// WEBPACK FOOTER
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/node_modules/swiper/esm/components/core/loop/index.js
// module id = 527
// module chunks = 4